import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

export interface OpenRovoSidePanelCommandProperties extends CommandProperties {
  /** Optional action ID to pre-select when opening the panel. */
  actionId?: string;
  /** Optional prompt text to pre-fill in the chat input without sending it. */
  prefillPrompt?: string;
}

/**
 * Command sent from databases to the Confluence host to open the Rovo side panel.
 * Mirrors the OpenRovoSidePanelCommand used by whiteboards.
 */
export const OpenRovoSidePanelCommand =
  createCommand<OpenRovoSidePanelCommandProperties>('open-rovo-side-panel');
